import { render, staticRenderFns } from "./EditablePerson.vue?vue&type=template&id=7b89ba04&scoped=true&"
import script from "./EditablePerson.vue?vue&type=script&lang=js&"
export * from "./EditablePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b89ba04",
  null
  
)

export default component.exports